// Maps invoice / quote / contract statuses to a tone. Tones are styled in theme.css.
const TONE = {
  // invoices
  draft: 'slate',
  open: 'blue',
  partial: 'amber',
  paid: 'green',
  overdue: 'red',
  void: 'slate',
  // quotes
  sent: 'blue',
  accepted: 'green',
  declined: 'red',
  expired: 'slate',
  converted: 'green',
  // contracts / runs
  active: 'green',
  paused: 'amber',
  cancelled: 'slate',
  ended: 'slate',
  failed: 'red',
  charged: 'green',
  invoiced: 'blue',
  // expenses
  pending: 'amber',
  approved: 'blue',
  posted: 'green',
  rejected: 'red',
  // jobs (open already mapped above)
  in_progress: 'amber',
  completed: 'green',
};

export default function StatusBadge({ status }) {
  const key = String(status || '').toLowerCase();
  const tone = TONE[key] || 'slate';
  const label = key ? key.replace(/_/g, ' ').replace(/^\w/, (ch) => ch.toUpperCase()) : '—';
  return <span className={`badge badge--${tone}`}>{label}</span>;
}
